module.exports = __webpack_public_path__ + "img/Jump Casting50.77239d88.jpg";